import styled from "styled-components";

export const ConfirmButton = styled.button`
  position: relative;
  height: auto;
  box-sizing: border-box;
  padding: ${(props) => props.theme.paddingButton};
  background-color: ${(props) => props.theme.colors.submitButton};
  border: ${(props) => `1px solid ${props.theme.colors.submitButton}`};
  color: ${(props) => props.theme.colors.submitButtonText};
  border-radius: ${(props) => props.theme.borderRadiusButton};
  outline: none;
  font-family: ${(props) => props.theme.fonts.button.family};
  font-size: ${(props) => props.theme.fonts.button.fontSize};
  line-height: ${(props) => props.theme.fonts.button.lineHeight};
  font-weight: ${(props) => props.theme.fonts.button.fontWeight};
  letter-spacing: ${(props) => props.theme.fonts.button.letterSpacing};
  pointer-events: ${(props) => (props.disabled ? "none" : undefined)};

  &:hover {
    background-color: ${(props) => props.theme.colors.submitButtonHover};
    border: ${(props) => `1px solid ${props.theme.colors.submitButtonHover}`};
    cursor: pointer;
  }

  &:focus::after {
    content: "";
    position: absolute;
    left: -4px;
    right: -4px;
    top: -4px;
    bottom: -4px;
    border: ${(props) => `2px solid ${props.theme.colors.highlight1}`};
    border-radius: ${(props) => props.theme.borderRadiusButton};
  }

  &:disabled {
    background-color: ${(props) => props.theme.colors.disabled1};
    border: ${(props) => `1px solid ${props.theme.colors.disabled1}`};
  }
`;
